// Sichere URLs aus Datenbankfeldern (onedrive_link, bild_url).
// Nur http(s) – „javascript:“, „data:“ usw. werden nie als Link oder Hintergrund gerendert.

/** Gibt die normalisierte URL zurück, wenn sie http(s) ist, sonst null. */
export function sichereUrl(roh: string | null | undefined): string | null {
  const wert = (roh ?? '').trim();
  if (!wert) return null;
  try {
    const u = new URL(wert);
    return u.protocol === 'https:' || u.protocol === 'http:' ? u.href : null;
  } catch {
    return null;
  }
}

/** CSS-Hintergrund für ein Foto – nur mit sicherer URL, Anführungszeichen maskiert; sonst null. */
export function fotoHintergrund(roh: string | null | undefined): string | null {
  const url = sichereUrl(roh);
  if (!url) return null;
  return `center / cover no-repeat url("${url.replace(/["\\\n\r]/g, c => encodeURIComponent(c))}")`;
}

/** Für Formulare: leer ist erlaubt, sonst muss es eine http(s)-Adresse sein. */
export function istGueltigeUrlEingabe(eingabe: string): boolean {
  return eingabe.trim() === '' || sichereUrl(eingabe) !== null;
}
